import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import App from '../../components/App/App';
import Prices from '../../components/Prices/Prices';

const PricesPage = ({}) => {
  return (
    <App>
      <Prices />
    </App>
  );
};

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
    revalidate: 40 * 40,
  };
};

export default PricesPage;
